import { useSelector } from 'react-redux';
import { getLRBalance } from '../duck/selectors';

export const useGetLRBalance = () => {
  const { data, isLoading } = useSelector(getLRBalance);

  return { balanceData: data, isLoading };
};
